export default __webpack_public_path__ + "static/media/icon-locked-cart.ca2d37a3.svg";